import { render, staticRenderFns } from "./ing.vue?vue&type=template&id=07968768&scoped=true&"
import script from "./ing.vue?vue&type=script&lang=js&"
export * from "./ing.vue?vue&type=script&lang=js&"
import style0 from "./ing.vue?vue&type=style&index=0&id=07968768&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07968768",
  null
  
)

export default component.exports